import React, { useEffect } from 'react';

const PrivacyPolicyPage = () => {
  useEffect(() => {
    if (!document.getElementById('fa-stylesheet')) {
      const linkFa = document.createElement('link');
      linkFa.id = 'fa-stylesheet';
      linkFa.rel = 'stylesheet';
      linkFa.href =
        'https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css';
      document.head.appendChild(linkFa);
    }
  }, []);

  return (
    <div className="min-h-screen bg-[#0B0F19] text-gray-200 font-sans py-12 px-6">
      <div className="max-w-4xl mx-auto bg-[#111827]/70 backdrop-blur-md p-8 md:p-12 rounded-[32px] border border-gray-800 shadow-2xl">

        {/* Header */}
        <div className="inline-block px-3 py-1 bg-emerald-500/10 border border-emerald-500/20 text-emerald-400 font-bold uppercase tracking-widest text-xs rounded-md mb-4">
          Data Security
        </div>

        <h1 className="text-3xl md:text-4xl font-black text-white mb-2">
          Privacy Policy
        </h1>

        <p className="text-sm text-gray-500 mb-6">
          Last Updated: June 2026
        </p>

        {/* Branding Section For Google Verification */}
        <div className="mb-8 p-4 rounded-xl bg-indigo-500/10 border border-indigo-500/20">
          <p className="text-sm text-gray-300 leading-relaxed">
            <strong className="text-white">VP Cafe Connect</strong> is the
            official digital services platform operated by{' '}
            <strong className="text-white">VP Cafe</strong> and accessible
            through our official website{' '}
            <strong className="text-white">vpcafe.in</strong>.
            This Privacy Policy applies to all services provided through
            VP Cafe Connect.
          </p>
        </div>

        <div className="border-b border-gray-800 pb-6 mb-8"></div>

        {/* Content */}
        <div className="space-y-8 text-gray-400 leading-relaxed text-sm md:text-base">

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              About VP Cafe Connect
            </h2>

            <p>
              VP Cafe Connect is the official digital services platform operated
              by VP Cafe. Through VP Cafe Connect, customers can access digital
              document processing, government application assistance,
              Aadhaar-related services, PAN services, online applications,
              cyber cafe facilities, and other digital support services.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              1. Information We Collect
            </h2>

            <p>
              To process your digital applications, we may collect personal
              identifiers including but not limited to: Name, Date of Birth,
              Address, Aadhaar Number, PAN Number, Biometrics (where strictly
              required for AEPS/Govt Authentication), Phone Number, and
              Email Address.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              2. Document Security & Anti-Forgery (Watermarking)
            </h2>

            <p>
              Your privacy and document security are our utmost priority.
              To prevent misuse of documents processed at our facility:
            </p>

            <ul className="list-disc pl-6 space-y-2 mt-3">
              <li>
                All unverified drafts and digital copies generated for
                customers may carry a digital watermark stating
                "VP INTERNET CAFE - SECURE CUSTOMER COPY".
              </li>

              <li>
                This helps prevent unauthorized modification, misuse,
                or fraudulent reproduction of customer documents.
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              3. How We Use Your Data
            </h2>

            <p>
              Data collected is strictly used for the specific service,
              form, application, or request initiated by the customer.
              We do not sell, rent, trade, or share personal data with
              third-party marketing agencies.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              4. Data Retention and Deletion
            </h2>

            <p>
              If you use our document storage or vault services,
              documents may be stored securely in encrypted form for
              customer convenience. Temporary files generated during
              routine processing are periodically removed from local
              systems according to operational requirements.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-white mb-3">
              5. Contact Us
            </h2>

            <p>
              For any privacy-related concerns, data deletion requests,
              or questions regarding this Privacy Policy, please contact:
            </p>

            <div className="mt-4 space-y-2">
              <p>
                <strong className="text-white">Platform:</strong> VP Cafe Connect
              </p>

              <p>
                <strong className="text-white">Operator:</strong> VP Cafe
              </p>

              <p>
                <strong className="text-white">Website:</strong> vpcafe.in
              </p>

              <p>
                <strong className="text-white">Email:</strong> admin@vpconnect.in
              </p>
            </div>
          </section>

        </div>

        {/* Footer */}
        <div className="mt-12 pt-8 border-t border-gray-800">
          <a
            href="/"
            className="inline-flex items-center text-emerald-400 hover:text-emerald-300 transition font-medium"
          >
            <i className="fa-solid fa-arrow-left mr-2"></i>
            Back to Home
          </a>
        </div>

      </div>
    </div>
  );
};

export default PrivacyPolicyPage;